module.exports = __webpack_public_path__ + "img/Search Staff.3ebcd0a5.svg";